/* sidemenu */
import $ from "jquery";

$(function() {
    
    var $toggle = $('.sidemenuToggle');
    const $sidemenuWrap = $toggle.closest('.sidemenu');
    const $accordionTriggers =  $('.sidemenu-menu button.AccordionTrigger');

    $toggle.click(function(event) {
        event.preventDefault();

        const $this = $(this);
        $sidemenuWrap.toggleClass('__active');

        // Open closed items if opening, close open items if closing
        if ($sidemenuWrap.hasClass('__active')) {
            $accordionTriggers.filter(':not(.__active)').trigger('click');
        } else {
            $accordionTriggers.filter('.__active').trigger('click');
        }


    });

    // Update the active state if any accordions are open/closed
    $accordionTriggers.on('click', function(e) {

        const total = $accordionTriggers.filter('.__active').length;

        if (0 < total) {
            $sidemenuWrap.addClass('__active');
        } else {
            $sidemenuWrap.removeClass('__active');
        }
   });
});
